export const betaTestPrivacyPolicyData = [
  { type: 'h1', content: 'Privacy Policy for Beta Test' },
  { type: 'h2', content: '1. Information We Collect' },
  {
    type: 'p',
    content: 'During your participation in the Beta Test, Pexar will collect the following personal information you voluntarily provide:',
  },
  {
    type: 'list',
    items: [
      { title: 'Age', text: '– to verify eligibility for participation.' },
      { title: 'Email address', text: '— for test communication, feedback collection, and follow-up.' },
      {
        title: 'Country/Region',
        text: '— to ensure compliance with regional regulations and enable language/localization support.',
      },
      {
        title: 'Postal address',
        text: '— used solely for the purpose of device shipment and logistics (if a physical testing unit is provided).',
      },
    ],
  },
  { type: 'p', content: 'We do not collect any sensitive personal data beyond the above-listed information.' },
  { type: 'h2', content: '2. Purpose of Data Use' },
  { type: 'p', content: 'Your data will be used exclusively for Beta Test-related purposes, including:' },
  {
    type: 'list',
    items: [
      { text: 'Managing participant recruitment and communication;' },
      { text: 'Shipping and tracking test devices (if applicable);' },
      { text: 'Gathering product feedback and improving product quality;' },
      { text: 'Contacting participants for follow-up or technical support.' },
    ],
  },
  { type: 'h2', content: '3. Data Sharing and Storage' },
  { type: 'p', content: "All data is stored securely on Pexar's protected servers." },
  {
    type: 'p',
    content: 'Your data will not be shared with any third parties except for authorized logistics or service providers directly involved in the Beta Test process, and only to the extent necessary to fulfill the purpose described above.',
  },
  { type: 'h2', content: '4. Data Retention' },
  { type: 'p', content: 'Same retention rules apply as described in Pexar Privacy Policy A.3.' },
  { type: 'p', className: 'last-updated', content: 'Last updated: 06/11/2025' },
];
